import * as Yup from 'yup'
import { isValid as isValidCpf, strip as stripCpf } from "@fnando/cpf"
import { isValid as isValidCnpj, strip as stripCnpj } from "@fnando/cnpj"
import cutileiApi from '../services/cutileiApi'
import Phone from '../services/Phone'
import Auth from '../services/auth'

const isNonExistingUser = async (key, value) => {
  const business = Auth.getUser ()
  const query = business ? `?business_id=${business.id}` : ''

  try {
    await cutileiApi.post (`/businesses/verify_existing${query}`, {
      [key]: value
    })
    return true
  } catch (error) {
    return false
  }
}

const phoneRegex = /\(|\)| |-/g

const editBusinessValidator = Yup.object ().shape ({
  name: Yup.string ()
    .required ('Digite um nome')
    .min (4, 'O nome deve conter no minimo 4 caracteres')
    .max (128, 'O nome deve conter até 128 caracteres'),
  
  corporate_name: Yup.string ()
    .required ('Digite a razão social')
    .min (4, 'A razão social deve ter no minimo 4 caracteres')
    .max (128, 'A razão social deve ter até 128 caracteres')
    .test ('newCorporateName', 'Esta razão social já foi cadastrada', async (value) => {
      if (value) {
        return isNonExistingUser ('corporate_name', value)
      }
    }),

  use_cnpj: Yup.boolean ().default (true),

  cnpj: Yup.string ()
    .when ('use_cnpj', {
      is: true,
      then: schema => schema
        .required ('Digite seu CNPJ')
        .test ('validCnpj', 'Digite um CNPJ válido', function (value) {
          if (!value) return false
          return isValidCnpj (value)
        })
        .test ('newCnpj', 'Este CNPJ já foi cadastrado', async (value) => {
          if (value) {
            return isNonExistingUser ('cnpj', stripCnpj (value))
          }
        }),
      otherwise: schema => schema
        .required ('Digite seu CPF')
        .test ('validCpf', 'Digite um CPF válido', function (value) {
          if (!value) return false
          return isValidCpf (value)
        })
        .test ('newCpf', 'Este CPF já foi cadastrado', async (value) => {
          if (value) {
            return isNonExistingUser ('cpf', stripCpf (value))
          }
        })
    }),

  email: Yup.string ()
    .required ('Digite um e-mail')
    .email ('Insira um e-mail válido')
    .max (128, 'O e-mail deve conter até 128 caracteres')
    .test ('newEmail', 'Este endereço de e-mail já foi cadastrado', async (value) => {
      if (value) {
        return isNonExistingUser ('email', value)
      }
    }),
    
  phone: Yup.string ()
    .test ('validPhone', 'Insira um telefone válido', function (value) {
      if (!value) return true
      return Phone.isValidPhoneNumber (value)
    })
    .test ('newPhone', 'Este número de telefone já foi cadastrado', async (value) => {
      if (value) {
        return isNonExistingUser ('phone', value.replace (phoneRegex, ''))
      }
      return true
    }),

  cellphone: Yup.string ()
    .required ('Digite o número de celular')
    .test ('validCellphone', 'Insira um celular válido', function (value) {
      if (!value) return true
      return Phone.isValidPhoneNumber (value)
    })
    .test ('newCellphone', 'Este número de celular já foi cadastrado', async (value) => {
      if (value) {
        return isNonExistingUser ('cellphone', value.replace (phoneRegex, ''))
      }
      return true
    }),

  owner: Yup.string ()
    .required ('Digite o nome do responsável')
    .min (4, 'O nome deve ter no minimo 4 caracteres')
    .max (128, 'O nome deve ter até 128 caracteres'),

  owner_email: Yup.string ()
    .required ('Digite o email do responsável')
    .email ('Insira um email válido')
    .max (128, 'O e-mail deve conter até 128 caracteres'),

  owner_phone: Yup.string ()
    .required ('Digite o número de celular')
    .test ('validCellphone', 'Insira um celular válido', function (value) {
      if (!value) return true
      return Phone.isValidPhoneNumber (value)
    }),

  address: Yup.object ().shape ({
    postal_code: Yup
      .string ()
      .required ('Digite o CEP')
      .test ('validPostalCode', 'Digite um CEP válido', function (value) {
        const rgRegex = (/^(\d{5})(\d{3})$/)
        return rgRegex.test (value)
      }),
  
    number: Yup
      .string ()
      .required ('Digite o número da residência')
      .max (5, 'O numero deve ter no máximo 5 digitos'),
  
    complement: Yup.string ()
  })
})

export default editBusinessValidator
